import React, { Suspense, useCallback } from 'react'
import styled from 'styled-components/macro'
import { Dialog, DialogTitle, Typography, IconButton, DialogContent, Grid, CircularProgress, Alert, Popover } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import { theme } from 'styled-tools'
import { usePermission } from '@tomfxs/permissions-client'
import { useInternalFlightDeck } from 'src/context/FlightDeckContext'
import ExploreIcon from '@mui/icons-material/Explore'

const CompanySelect = React.lazy(() => loadComponent('orga', 'CompanySelect'))
const AcademySelect = React.lazy(() => loadComponent('traiwiss', 'AcademySelect'))

const FlightDeckButton = styled(IconButton)`
    color: gray;
    border-radius: 50%;
    height: auto;
    width: 35px;
    height: 35px;
`

const CloseButton = styled(IconButton)`
    position: absolute !important;
    top: ${({ theme }) => theme.spacing(1)};
    right: ${({ theme }) => theme.spacing(1)};
    color: ${theme('palette.grey.500')};
`

const StyledDialogContent = styled(DialogContent)`
    padding-bottom: ${({ theme }) => theme.spacing(2)};
`

export function FlightDeck() {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
    const { company, changeCompany, academy, changeAcademy } = useFlightDeck()
    const { setFlightDeckOpen, flightDeckDialogOpen } = useInternalFlightDeck()

    const onOpen = useCallback(() => setFlightDeckOpen(true), [setFlightDeckOpen])
    const onClose = useCallback(() => setFlightDeckOpen(false), [setFlightDeckOpen])

    const open = Boolean(anchorEl)

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handlePopoverClose = () => {
        setAnchorEl(null)
    }

    const canViewCompanies = usePermission('orga.company.view', {})
    const canViewAcademies = usePermission('traiwiss.academy.view', {})

    return (
        <>
            <FlightDeckButton onClick={onOpen} size="large" onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
                <ExploreIcon fontSize="large" />
            </FlightDeckButton>
            <Popover
                id="mouse-over-popover"
                sx={{
                    pointerEvents: 'none',
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus>
                {canViewCompanies && (
                    <Typography component="div" sx={{ p: 1 }}>
                        Firma: {!company?.name ? 'Bitte auswählen' : company?.name}
                    </Typography>
                )}
                {canViewAcademies && <Typography sx={{ p: 1 }}>Akademie: {!academy?.name ? 'Bitte auswählen' : academy?.name}</Typography>}
            </Popover>
            <Dialog open={flightDeckDialogOpen} fullWidth maxWidth="md" onClose={onClose}>
                <DialogTitle>
                    <Typography variant="h6">Deine Schaltzentrale</Typography>
                    <CloseButton onClick={onClose}>
                        <CloseIcon />
                    </CloseButton>
                </DialogTitle>
                <StyledDialogContent>
                    <Suspense fallback={<CircularProgress />}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Alert severity="info">
                                    Hier definierst du, in welchem Kontext du dich innerhalb von traiwiss bewegst.
                                </Alert>
                            </Grid>
                            {canViewCompanies && (
                                <Grid item xs={6}>
                                    <CompanySelect selectedCompany={company} onChange={changeCompany} />
                                </Grid>
                            )}
                            {canViewAcademies && (
                                <Grid item xs={6}>
                                    <AcademySelect selectedAcademy={academy} onChange={changeAcademy} />
                                </Grid>
                            )}
                        </Grid>
                    </Suspense>
                </StyledDialogContent>
            </Dialog>
        </>
    )
}
